import { apiService } from './index';

// Inport types
import { ISelect } from '../shared/types/shared';

export const asyncGetCities = async (): Promise<ISelect[]> => {
    try {
        return await apiService.get(`/api/location/cities/`);
    } catch (error) {
        return [];
    }
};

export const asyncGetCountries = async (): Promise<ISelect[]> => {
    try {
        return await apiService.get(`/api/location/countries/`);
    } catch (error) {
        return [];
    }
};

export const asyncGetForeignCities = async (): Promise<ISelect[]> => {
    try {
        return await apiService.get(`/api/location/foreign-cities/`);
    } catch (error) {
        return [];
    }
};

export const asyncGetCountry = async (
    idCountry: string
): Promise<ISelect | undefined> => {
    try {
        return await apiService.get(`/api/location/country/${idCountry}`);
    } catch (error) {
        return;
    }
};

export const asyncGetCountryByCode = async (
    code: string
): Promise<ISelect | undefined> => {
    try {
        return await apiService.get(`/api/location/country-by-code/${code}`);
    } catch (error) {
        return;
    }
};
